import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Icon, IconSize } from '../../../core/models/icon.model';

@Component({
  selector: 'umkt-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './icon.component.html',
})
export class IconComponent {
  @Input() icon?: Icon;
  @Input() size: IconSize = 'md';
}
